<template>
  <div class="homework-topbar">
    <div class="homework-list-topbar">
      <div class="topbar-operation">
        <div class="operation-left">
          <search class="search" placeholder="输入作业标题筛选作业" @search="search" />
          <el-cascader class="select" style="margin-left: 30px" v-model="classNameVal" :placeholder="classPlaceholder"
            :props="classProps" :options="classSelect" clearable @change="changeHandle"></el-cascader>
          <!-- <el-date-picker
            class="select"
            v-model="schoolYearVal"
            type="year"
            placeholder="学年"
            @change="schoolYearChangeHandle"
          >
          </el-date-picker> -->
          <el-select class="select" v-model="semesterVal" placeholder="学期" clearable @change="semesterChangeHandle">
            <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
          </el-select>
          <year-range-picker class="select" style="width: 250px;" v-model="schoolYearVal" @change="schoolYearChangeHandle" />
        </div>
        <div class="operation-right">
          <el-date-picker v-model="isDatePickerShow" type="date" value-format="yyyy-MM-dd HH:mm" placeholder="选择日期筛选作业"
            size="small" @change="datePickerChange">
          </el-date-picker>
        </div>
      </div>
    </div>
    <div class="topbar-tabs">
      <div class="tab-item" :class="currentCourseItem == index ? 'current-item' : ''"
        v-for="(item, index) in courseList" :key="index" @click="changeCurrentTabItem(index)"
        :style="{ 'animation-duration': `${(index + 1) * 0.2}s` }">
        {{ item.courseName ? item.courseName : "全部" }}
      </div>
    </div>
  </div>
</template>

<script>
import search from "@/components/search/search.vue";
export default {
  components: {
    search,
  },
  data() {
    return {
      currentCourseItem: 0,
      isDatePickerShow: "",
      classNameVal: "",
      schoolYearVal: "", // 学年
      semesterVal: "", // 学期
    };
  },
  // props: {
  //   courseList: {
  //     type: Array,
  //     require: true,
  //   },
  // },
  props: [
    "schoolYear",
    "semester",
    "className",
    "classPlaceholder",
    "classProps",
    "classSelect",
    "courseList",
    "semesterOptions",
  ],
  mounted() {
    this.classNameVal = this.className;
    setTimeout(() => {
      this.schoolYearVal = this.schoolYear;
      this.semesterVal = this.semester;
    }, 300);
  },
  methods: {
    schoolYearChangeHandle(e) {
      // let schoolYear = e ? "" + e.getFullYear() : "";
      this.$emit("schoolYearChangeHandle", this.schoolYearVal);
    },
    semesterChangeHandle(e) {
      this.$emit("semesterChangeHandle", e);
    },
    // 选择班级
    changeHandle(e) {
      this.$emit("changeHandle", e);
    },
    changeCurrentTabItem(tabsIndex) {
      this.currentCourseItem = tabsIndex;
      this.$emit("input", this.currentCourseItem);
    },
    showDatePicker() {
      this.isDatePickerShow = true;
    },
    datePickerChange(e) {
      this.$emit("pickDate", e);
    },
    search(e) {
      this.$emit("search", e);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./homeworkListTopbar.scss";
</style>
